// src/components/annotations/DraftSessionBadge.jsx
import { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'src/redux/store';
import { callApi } from 'src/utils/apiCall';

/**
 * Tiny inline badge that shows the count of draft annotation sessions.
 * Designed to sit in the `info` slot of a nav item (same pattern as
 * the Emails unread badge in NavItem.jsx).
 *
 * Fetches once on mount and re-fetches when practiceId changes.
 */
export default function DraftSessionBadge() {
  const { practiceId } = useSelector((state) => state.practiceTreatmentList);
  const [count, setCount] = useState(0);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  useEffect(() => {
    if (!practiceId) return;
    (async () => {
      try {
        const res = await callApi(
          `/api/v1/practices/${practiceId}/annotation-sessions/?status=draft`,
          'GET'
        );
        if (res.ok && mountedRef.current) {
          const results = res.data?.results ?? res.data ?? [];
          setCount(Array.isArray(results) ? results.length : 0);
        }
      } catch (_) {
        // Non-fatal — badge just stays hidden
      }
    })();
  }, [practiceId]);

  if (!count) return null;

  return (
    <Box
      sx={{
        minWidth: 20,
        height: 20,
        borderRadius: '10px',
        bgcolor: '#FF9800',
        color: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.7rem',
        fontWeight: 700,
        px: 0.5,
        lineHeight: 1,
      }}
    >
      {count}
    </Box>
  );
}
